import { HeaderData } from './types';
import { useReport } from './hooks/use-context';

export function Header({ formName }: { formName?: string }) {
  const { header } = useReport();
  const data = header as HeaderData;

  const cellStyle = {
    padding: '8px',
    border: '1px solid black',
    textAlign: 'center' as const,
    verticalAlign: 'middle' as const,
  };

  const getStatus = (status: string) => {
    switch (status) {
      case 'done':
        return 'Finalizado';
      case 'pending':
        return 'Pendente';
      case 'started':
        return 'Iniciado';
      case 'draft':
        return 'Rascunho';
      case 'rescheduled':
        return 'Reagendado';
      case 'incomplete':
        return 'Incompleto';
      case 'delayed':
        return 'Atrasado';
      default:
        return status;
    }
  };

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '3fr 5fr 3fr',
        border: '1px solid black',
        borderBottom: 'none',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <div
        style={{
          ...cellStyle,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {data.logo ? (
          <img
            src={data.logo}
            alt="Logo"
            style={{ maxWidth: '100px', maxHeight: '50px' }}
          />
        ) : (
          <div style={{ fontWeight: 'bold' }}>Logo</div>
        )}
      </div>

      <div
        style={{
          ...cellStyle,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '18px',
        }}
      >
        <div>{data.company_name}</div>
        <div style={{ marginTop: '8px' }}>
          {formName || data.formulary_name || 'Registro de Desvios'}
        </div>
      </div>

      <div
        style={{
          ...cellStyle,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          fontSize: '14px',
          textAlign: 'left',
          paddingLeft: '16px',
        }}
      >
        <div style={{ marginBottom: '4px' }}>
          <strong>Data/Hora de Início:</strong>{' '}
          {data.event_date_time}
        </div>
        <div style={{ marginBottom: '4px' }}>
          <strong>Data/Hora de Fim:</strong>{' '}
          {data.event_finished_at || '-'}
        </div>
        <div>
          <strong>Status:</strong> {getStatus(data.status)}
        </div>
      </div>
    </div>
  );
}
